import React, { useEffect, useState } from "react";
import { Button, Col, Input, Row } from "reactstrap";
import _ from "lodash";
import { useLocation } from "react-router-dom";
import { ItemTypeahead } from "./";
import { api } from "../utils";
import { DesktopContainer } from "../layouts";
import { toast } from "react-toastify";
import Select from "react-select";
import CustomerTypeahead from "./CustomerTypeahead";

export default function LateShipment() {
   const location = useLocation();
   const [customer, setCustomer] = useState(
      location?.state?.customer ? location?.state?.customer : null
   );
   const [carriers, setCarriers] = useState([]);
   const [comments, setComments] = useState("");
   const [fullOrders, setFullOrders] = useState([]); // Want to hold on to full list to use required ship date in saving to db.
   const [isWorking, setIsWorking] = useState(false);
   const [machines, setMachines] = useState([]);
   const [orders, setOrders] = useState([]);
   const [reasons, setReasons] = useState([]);
   const [selectedCarrier, setSelectedCarrier] = useState(null);
   const [selectedItem, setSelectedItem] = useState(null);
   const [selectedMachine, setSelectedMachine] = useState(null);
   const [selectedOrder, setSelectedOrder] = useState(null);
   const [selectedReason, setSelectedReason] = useState(null);
   const [shipmentId, setShipmentId] = useState(0);

   useEffect(() => {
      getLateShipmentReasons();
      getRepairMachineSetupNames();
      getShippingCompanies();
   }, []);

   useEffect(() => {
      if (!customer?.value) {
         return;
      }
      getCustomerOrders();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [customer]);

   useEffect(() => {
      if (!selectedOrder?.value) {
         return;
      }
      getLateShipment();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [selectedOrder]);

   function getCustomerOrders() {
      api
         .fetch(`Sales/GetLateShipmentCustomerOrders/${customer?.value}`)
         .then((response) => {
            if (response && response.data && response.data.success) {
               setFullOrders(response.data.message);
               let list = _.map(response.data.message, (x) => {
                  return { value: x.orderType, label: x.orderId };
               });
               list.unshift({ value: "", label: "--- Orders ---" });
               if (location?.state?.orderId) {
                  setSelectedOrder(
                     _.find(list, function (x) {
                        return x.label.trim() === location?.state?.orderId;
                     })
                  );
               } else {
                  setSelectedOrder({ value: "", label: "--- Orders ---" });
               }
               setOrders(list);
            }
         })
         .catch(api.catchHandler);
   }

   function getLateShipment() {
      let payload = {
         CustomerId: customer?.value,
         OrderId: selectedOrder?.label,
         OrderType: selectedOrder?.value,
      };

      api
         .post("Sales/GetLateShipment", payload)
         .then((response) => {
            if (response && response.data.success && response.data.message) {
               let shipment = response.data.message;
               setShipmentId(shipment.id);
               setSelectedReason({
                  value: shipment.reasonId,
                  label: shipment.reason,
               });
               setComments(shipment.comments);
               if (shipment.reasonId === 1) {
                  setSelectedMachine(
                     _.find(machines, ["value", shipment.reasonType])
                  );
               } else if (shipment.reasonId === 4) {
                  setSelectedCarrier(
                     _.find(carriers, ["value", shipment.reasonType])
                  );
               }
            }
         })
         .catch(api.catchHandler);
   }

   function getLateShipmentReasons() {
      api
         .fetch("Sales/GetActiveLateReasons")
         .then((response) => {
            if (response && response.data && response.data.success) {
               let list = _.map(response.data.reasons, (x) => {
                  return { value: x.reasonId, label: x.reason };
               });
               list.unshift({ value: "", label: "--- Select ---" });
               setReasons(list);
            }
         })
         .catch(api.catchHandler);
   }

   function getRepairMachineSetupNames() {
      api
         .fetch("Repair/GetRepairMachineSetupNames")
         .then((response) => {
            if (response && response.data.success) {
               let list = _.map(response.data.message, (x) => {
                  return { value: x.shortName, label: x.name };
               });
               list.unshift({ value: "", label: "--- Select ---" });
               setMachines(list);
            }
         })
         .catch(api.catchHandler);
   }

   function getReqDate() {
      let order = _.find(fullOrders, ["orderId", selectedOrder?.label]);
      return order.requiredShipDate;
   }

   function getShippingCompanies() {
      api
         .fetch("Reference/GetShippingCompanyList")
         .then((response) => {
            if (response && response.data.success) {
               let list = _.map(response.data.companies, (x) => {
                  return { value: x.ddlValue, label: x.ddlDescription };
               });
               list.unshift({ value: "", label: "--- Select Shipping Method ---" });
               setCarriers(list);
            }
         })
         .catch(api.catchHandler);
   }

   function onChangeCustomer(e) {
      setCustomer(e);
      setSelectedReason({ value: "", label: "--- Select ---" });
      setSelectedOrder({ value: "", label: "--- Orders ---" });
      setSelectedCarrier(null);
      setSelectedItem(null);
      setSelectedMachine(null);
      setComments("");
      setShipmentId(0);
   }

   function onChangeOrder(e) {
      setShipmentId(0);
      setComments("");
      setSelectedReason({ value: "", label: "--- Select ---" });
      setSelectedCarrier(null);
      setSelectedItem(null);
      setSelectedMachine(null);
      setSelectedOrder(e);
   }

   function saveLateShipment() {
      if (!selectedReason || !selectedReason.value || selectedReason.value === "") {
         toast.error("A reason type must be selected.");
         return;
      }

      if (comments.length > 500) {
         toast.error("Comments are limited to 500 characters.");
         return;
      }

      setIsWorking(true);
      let payload = {
         Id: shipmentId,
         Comments: comments,
         Created: new Date(),
         ReqDate: getReqDate(),
         CustomerId: customer?.value,
         ReasonId: selectedReason?.value,
         OrderId: selectedOrder?.label,
         OrderType: selectedOrder?.value,
      };

      if (selectedReason?.value === 1) {
         payload.ReasonType = selectedMachine?.value;
      } else if (selectedReason?.value === 2) {
         payload.ReasonType = selectedItem?.ddlValue;
      } else if (selectedReason?.value === 4) {
         payload.ReasonType = selectedCarrier?.value;
      } else {
         payload.ReasonType = "";
      }

      api
         .post("Sales/SaveLateShipment", payload)
         .then((response) => {
            if (response && response.data.success) {
               toast.success(
                  `Late Shipment saved for order: ${selectedOrder?.label} for ${customer?.value}`
               );
            }
         })
         .catch(api.catchHandler)
         .finally(() => setIsWorking(false));
   }

   return (
      <DesktopContainer screenName="Late Shipment">
         <div className="filter-header">
            <Row className="mt-3 d-flex justify-content-center align-items-center">
               <Col xs="6">
                  <Row className="mt-3 d-flex align-items-center">
                     <Col xs="3" className="d-flex justify-content-end">
                        <p className="m-0" style={{ fontSize: "1.25rem", color: "white" }} >
                           Customer:
                        </p>
                     </Col>
                     <Col xs="7">
                        <CustomerTypeahead value={customer || ""} onChange={(e) => onChangeCustomer(e)} />
                     </Col>
                  </Row>
                  <Row className="mt-3 d-flex align-items-center">
                     <Col xs="3" className="d-flex justify-content-end">
                        <p className="m-0" style={{ fontSize: "1.25rem", color: "white" }} >
                           Orders:
                        </p>
                     </Col>
                     <Col xs="7">
                        <Select
                           classNamePrefix="serviceThreadSelect"
                           options={orders}
                           value={selectedOrder}
                           onChange={(e) => onChangeOrder(e)}
                           getOptionValue={(option) => option}
                        />
                     </Col>
                  </Row>
                  <Row className="mt-3 d-flex align-items-center">
                     <Col xs="3" className="d-flex justify-content-end">
                        <p className="m-0" style={{ fontSize: "1.25rem", color: "white" }} >
                           Reason:
                        </p>
                     </Col>
                     <Col xs="7">
                        <Select
                           classNamePrefix="serviceThreadSelect"
                           options={reasons}
                           value={selectedReason}
                           onChange={(e) => setSelectedReason(e)}
                        />
                     </Col>
                  </Row>
                  {selectedReason?.label === "Machine Issue" ? (
                     <Row className="mt-3 d-flex align-items-center">
                        <Col xs="3" className="d-flex justify-content-end">
                           <p className="m-0" style={{ fontSize: "1.25rem", color: "white" }} >
                              Machine:
                           </p>
                        </Col>
                        <Col xs="7">
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={machines}
                              value={selectedMachine}
                              onChange={(e) => setSelectedMachine(e)}
                           />
                        </Col>
                     </Row>
                  ) : null}
                  {selectedReason?.label === "Transportation" ? (
                     <Row className="mt-3 d-flex align-items-center">
                        <Col xs="3" className="d-flex justify-content-end">
                           <p className="m-0" style={{ fontSize: "1.25rem", color: "white" }} >
                              Carrier:
                           </p>
                        </Col>
                        <Col xs="7">
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={carriers}
                              value={selectedCarrier}
                              onChange={(e) => setSelectedCarrier(e)}
                           />
                        </Col>
                     </Row>
                  ) : null}
                  {selectedReason?.label === "Material Shortage" ? (
                     <Row className="mt-3 d-flex align-items-center">
                        <Col xs="3" className="d-flex justify-content-end">
                           <p className="m-0" style={{ fontSize: "1.25rem", color: "white" }} >
                              PM Item:
                           </p>
                        </Col>
                        <Col xs="7">
                           <ItemTypeahead value={selectedItem} onChange={(e) => setSelectedItem(e)} purchasedMaterialsOnly />
                        </Col>
                     </Row>
                  ) : null}
                  <Row className="mt-3 d-flex align-items-center">
                     <Col xs="3" className="d-flex justify-content-end">
                        <p className="m-0" style={{ fontSize: "1.25rem", color: "white" }} >
                           Comments:
                        </p>
                     </Col>
                     <Col xs="7">
                        <Input
                           className="serviceThreadTextArea"
                           type="textarea"
                           maxLength={500}
                           value={comments}
                           onChange={(e) => setComments(e.target.value)}
                        />
                     </Col>
                  </Row>
                  <Row className="mt-3 d-flex align-items-center">
                     <Col xs="3" className="d-flex justify-content-end">
                        <Button className="shredButton" onClick={() => saveLateShipment()} disabled={isWorking} >
                           SAVE
                        </Button>
                     </Col>
                     <Col xs="7"></Col>
                  </Row>
               </Col>
            </Row>
         </div>
      </DesktopContainer>
   );
}
